import { classNames } from "@circle-react/helpers/twMergeWithCN";
import isFunction from "lodash/isFunction";

import { TippyV2 as Tippy } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { TextModifierIcon } from "./TextModifierIcon";

interface TextModifierButtonProps {
  iconClassName?: string;
  iconSize?: number;
  iconType: string;
  isActive?: boolean;
  label?: string;
  onClick?: () => void;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
}

export const TextModifierButton = ({
  label,
  isActive,
  onClick,
  tooltipPlacement = "top",
  iconType,
  iconSize,
  iconClassName,
}: TextModifierButtonProps) => {
  const IconButton = (
    <button
      type="button"
      aria-label={label}
      onClick={() => isFunction(onClick) && onClick()}
      className={classNames(
        "rounded-full p-1.5",
        "text-default",
        "hover:bg-secondary",
        {
          "bg-tertiary text-dark": isActive,
        },
      )}
    >
      <TextModifierIcon
        type={iconType}
        iconSize={iconSize}
        className={iconClassName}
      />
    </button>
  );

  if (label) {
    return (
      <Tippy
        content={label}
        placement={tooltipPlacement}
        theme="text-modifiers-tooltip"
      >
        {IconButton}
      </Tippy>
    );
  }
  return <>{IconButton}</>;
};
